import React from "react";
import styles from "./NotFound.module.css";
import { Link } from "react-router-dom";

const NotFound = () => (
  <section className={styles.polzovatelskoeSoglashenie}>
      <h1 className={styles.title}>Не найдено</h1>
      <Link to="/">Вернуться на главную</Link>
  </section>
);

export default NotFound;
